import { Component, inject } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { DialogComponent } from '@ui/Components/Dialog/Dialog.Component'
import { DialogActionsComponent } from '@ui/Components/Dialog/DialogActions.Component'
import { ButtonComponent } from '@ui/Components/Form/Button/Button.Component'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'delete-dialog',
	templateUrl: './ConfirmDeleteDialog.Component.html',
	imports: [DialogComponent, DialogActionsComponent, ButtonComponent, NgStyle],
})
export class ConfirmDeleteDialogComponent {
	private readonly dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>

	constructor() {
		this.dialogRef = inject(MatDialogRef<ConfirmDeleteDialogComponent>)
	}

	public closeDialog = () => {
		this.dialogRef.close(false)
	}

	public confirmAndClose = () => {
		this.dialogRef.close(true)
	}
}
